import styled from 'styled-components';

export const Container = styled.section`
  display: block;
  margin-top: 32px;
`;

export const Padding = styled.div`
  padding: 0 15px;
`;
